import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

// Generates a paginated A4 PDF of the rendered contract document (the
// off-screen capture node). Uses html2canvas + jsPDF directly instead of
// html2pdf: the installed html2canvas measures the node deterministically
// and paints the signature image into the canvas, so the PDF carries the
// full contract letter plus the candidate's signature.
export const generateContractPdf = async (node: HTMLElement, filename: string): Promise<void> => {
  const canvas = await html2canvas(node, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
  });

  const doc = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
  const margin = 15;
  const pageWidthMm = 210;
  const pageHeightMm = 297;
  const imageWidthMm = pageWidthMm - margin * 2;
  const usableHeightMm = pageHeightMm - margin * 2;

  const imageHeightMm = (canvas.height / canvas.width) * imageWidthMm;
  const totalPages = Math.max(1, Math.ceil(imageHeightMm / usableHeightMm));
  const pageHeightPx = Math.ceil(canvas.height / totalPages);

  for (let page = 0; page < totalPages; page++) {
    if (page > 0) doc.addPage();
    const srcY = page * pageHeightPx;
    const srcH = Math.min(pageHeightPx, canvas.height - srcY);

    const slice = document.createElement("canvas");
    slice.width = canvas.width;
    slice.height = srcH;
    const ctx = slice.getContext("2d");
    if (!ctx) continue;
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, slice.width, slice.height);
    ctx.drawImage(canvas, 0, srcY, canvas.width, srcH, 0, 0, canvas.width, srcH);

    const sliceHeightMm = (srcH / canvas.width) * imageWidthMm;
    doc.addImage(slice.toDataURL("image/jpeg", 0.95), "JPEG", margin, margin, imageWidthMm, sliceHeightMm);
  }

  doc.save(filename);
};
